export class PATTERNS {
    public static email = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
    public static mobile = "^[0-9]{10}$";
    public static Name = "^(?!.* {2,})([A-Za-z]+(?: [A-Za-z]+){0,2})$";
    public static rate = "^(?:[0-9](?:\\.[0-9]{1,2})?|[1-9](?:\\.[0-9]{1,2})?)$";
    public static countryCode = "^\\+\\d{1,3}$";
}
